import React, { useEffect, useState } from "react";
import InsurranceMenu from "./InsurranceMenu"
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import InsurranceTopMenu from "./InsurranceTopMenu";


const InsurranceTab = (props) => {
    const MenuItems = InsurranceMenu();
    const activeTabElement = MenuItems.filter((item) => item.right === true)[0]
    const [tabList, setTabsList] = useState([])
    const [activeTab, setActiveTab] = useState(61)
    const [component, setComponent] = useState({})
    console.log(props.ActivePatientID, 'insuranceTab');
    

    useEffect(() => {
        const activeComponent = MenuItems.filter((tab, key) => {
            return tab.right === true
        })[0]
        setComponent(activeComponent)
    }, [activeTab])
    const handleActiveTab = (item) => {
        const { key, name, right } = { ...item }
        let dynamicTabs = [...tabList]
        if (tabList.length === 0) {
            const obj = {
                key: activeTabElement.key,
                name: activeTabElement.name,
                right: activeTabElement.right,
            }
            dynamicTabs.push(obj)
        }
        const newTabObject = {
            key: key,
            name: name,
            right: right,
        }
        const isTabExist = dynamicTabs.filter((tab) => {
            return tab.name === name
        })
        if (!(isTabExist && isTabExist.length > 0)) {
            dynamicTabs = [...dynamicTabs, newTabObject]
            setTabsList(dynamicTabs)
        }
        if (activeTab !== key) {
            setActiveTab(key)
        }
    }
    return (

        <>
         <div className='app-tabs fix-tabs'>
            {tabList.length > 0 ? (
                <>
                    <TabContent activeTab={activeTab}>
                        {tabList &&
                            tabList.map((item) => {
                                return (
                                    <React.Fragment key={item.key}>
                                        <TabPane tabId={item.key}>
                                            <div>
                                                <div>
                                                    <InsurranceTopMenu subCategKey={item.key} Reload ={props.Reload} ActivePatientID={props.ActivePatientID}/>
                                                </div>
                                            </div>
                                        </TabPane>
                                    </React.Fragment>
                                )
                            })}
                    </TabContent>
                </>
            ) : (
                    <TabContent activeTab={component.key}>
                        <React.Fragment key={component.key}>
                            <TabPane tabId={component.key}>
                                <InsurranceTopMenu subCategKey={component.key} Reload ={props.Reload} ActivePatientID={props.ActivePatientID} />
                            </TabPane>
                        </React.Fragment>
                    </TabContent>
            )}
         </div>
        </>

    )
}
export default InsurranceTab